<script lang="ts" setup>
import ListItem from './PageHeaderListItem.vue';
import ResourceTools from './ResourceTools.vue';
</script>

<template>
  <ul class="m-0 flex list-none justify-between px-0 py-32">
    <li class="flex flex-col gap-y-16">
      <div class="text-14 color-#A1A1A1 font-400 leading-17">关于我们</div>
      <ul class="m-0 w-331 list-none p-0">
        <li>
          <ListItem title="简介" description="了解我们的历史、业务范围及使命" to="/about/introduction" />
        </li>
        <li>
          <ListItem title="组织架构" description="了解我们的结构及工作内容" to="/about/structure" />
        </li>
        <li>
          <ListItem title="理事及监事信息" description="了解我们的理事会人员构成" to="/about/council" />
        </li>
      </ul>
    </li>

    <li class="flex flex-col gap-y-16">
      <div class="text-14 color-#A1A1A1 font-400 leading-17">&nbsp;</div>
      <ul class="m-0 w-331 list-none p-0">
        <li>
          <ListItem title="技术监督委员会（TOC）" description="了解我们的委员及导师信息" to="/about/toc" />
        </li>
        <li>
          <ListItem title="开源安全委员会" description="了解那些单位为我们提供安全保障工作" to="/about/security" />
        </li>
        <li>
          <ListItem title="开放原子云社区" description="构建开源、开放的云原生技术生态，探索云原生技术创新" to="/about/cloud" />
        </li>
      </ul>
    </li>

    <ResourceTools />
  </ul>
</template>
